import { render } from "./download.vue?vue&type=template&id=b0a1b900&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=b0a1b900&lang=scss&scoped=true"
import "./download.vue?vue&type=style&index=1&id=b0a1b900&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a1b900"]])

export default __exports__